
<section class="nedit-dashboard">


  <!-- Search, page size and refresh -->
  <div class="toolbar">

    <div class="search-area">
      <input id="articleSearch"
             type="search"
             [(ngModel)]="searchText"
             (input)="applyFilter()"
             placeholder="Search journal, article, status..."
             autocomplete="off" />

      <button type="button"
              class="clear-button"
              (click)="clearSearch()"
              [disabled]="!searchText">
        Clear
      </button>
    </div>

    <label class="page-size-control">
      <span>Rows per page</span>

      <select [value]="pageSize"
              (change)="onPageSizeChange($any($event.target).value)">
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </label>

    <!-- Refresh button -->
    <button type="button"
            class="refresh-button"
            (click)="refreshData()"
            [disabled]="loading">

      <i class="fa fa-refresh" [class.fa-spin]="loading"></i>
      <span>{{ loading ? 'Refreshing...' : 'Refresh Data' }}</span>

    </button>

  </div>


  <!-- Loading -->
  <div *ngIf="loading" class="message info-message">
    Loading article data...
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="message error-message">
    {{ errorMessage }}
  </div>

  <!-- Dashboard table -->
  <ng-container *ngIf="!loading && !errorMessage">

    <div class="table-wrapper">

      <table class="article-table">

        <thead>
          <tr>
            <th>JOURNAL</th>
            <th>ARTICLE</th>
            <th>LINK SENT ON</th>
            <th>STATUS</th>
            <th>ACTION</th>
          </tr>
        </thead>

        <tbody>

          <tr *ngFor="let article of pagedArticles; trackBy: trackByArticle"
              [class.archived-row]="
              (article.article_status || '').toLowerCase() === 'archived'
            ">

            <td>{{ article.journalCode || '-' }}</td>

            <td class="article-id">
              {{ article.articleId || '-' }}
            </td>

            <td class="date-cell">
              {{ article.proof_link_sent || '-' }}
            </td>

            <!-- Workflow status -->
            <td class="status-cell">

              <ng-container *ngFor="let workflow of article.workflow_details">

                <div class="workflow-line">

                  <span *ngIf="workflow.article_workflow_status == '2'"
                        class="workflow-check">
                    ✔
                  </span>

                  <strong class="workflow-stage"
                          [class.stage-completed]="
                      workflow.article_workflow_status == '2'
                    ">
                    {{ (workflow.stage_name || 'UNKNOWN') | uppercase }}
                  </strong>

                  <span>
                    -
                    {{
                      workflow.article_workflow_status == '2'
                        ? 'Completed'
                        : 'In Progress'
                    }}
                  </span>

                  <span *ngIf="workflow.submitted_on">
                    - {{ workflow.submitted_on }}
                  </span>

                </div>

              </ng-container>

              <div *ngIf="!article.workflow_details?.length"
                   class="empty-status">
                {{ article.article_status || '-' }}
              </div>

            </td>

            <!-- Action column -->
            <td class="action-cell">

              <ng-container *ngIf="
                ['archived', 'in progress'].includes(
                  (article.article_status || '').toLowerCase().trim()
                )
                else availableActions
              ">
                <span class="archived-badge">
                  <span class="archive-dot"></span>
                  {{
                    (article.article_status || '').toLowerCase().trim() === 'archived'
                      ? 'Article Archived'
                      : 'Article In Progress'
                  }}
                </span>
              </ng-container>

              <ng-template #availableActions>

                <div class="action-buttons">

                  <!-- First proof -->
                  <a *ngIf="article.first_proof_link"
                     [href]="article.first_proof_link"
                     target="_blank"
                     rel="noopener noreferrer"
                     class="action-btn pdf-btn"
                     title="Open first proof">

                    <span class="action-icon zip-icon">
                      <i class="fa fa-file-archive-o"></i>
                    </span>
                    <span>PROOF</span>

                  </a>

                  <!-- Workflow files with stage name -->
                  <ng-container *ngFor="let workflow of article.workflow_details">

                    <a *ngIf="workflow.snap_path && workflow.article_workflow_status !='0'"
                       [href]="workflow.snap_path"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="action-btn file-btn"
                       [title]="'Open ' + (workflow.stage_name || 'workflow file' | uppercase)">

                      <span class="action-icon pdf-icon">
                        <i class="fa fa-file-pdf-o"></i>
                      </span>

                      <span>{{ workflow.stage_name || 'PDF' | uppercase }}</span>

                    </a>

                  </ng-container>

                  <!-- No files available -->
                  <span *ngIf="
                        !article.first_proof_link &&
                        !hasWorkflowFiles(article)
                      "
                        class="no-action">
                    -
                  </span>

                </div>

              </ng-template>

            </td>

          </tr>

          <!-- No results -->
          <tr *ngIf="filteredArticles.length === 0">
            <td colspan="5" class="no-results">
              No matching articles found.
            </td>
          </tr>

        </tbody>

      </table>

    </div>

    <!-- Pagination stays outside the scrolling table -->
    <div class="table-footer">

      <span class="record-summary">
        Showing {{ firstRecordNumber | number }}–{{
          lastRecordNumber | number
        }}
        of {{ filteredArticles.length | number }} articles
      </span>

      <div class="pagination-controls">

        <button type="button"
                (click)="previousPage()"
                [disabled]="currentPage <= 1">
          Previous
        </button>

        <span class="page-number">
          Page {{ currentPage }} of {{ totalPages }}
        </span>

        <button type="button"
                (click)="nextPage()"
                [disabled]="currentPage >= totalPages">
          Next
        </button>

      </div>

    </div>

  </ng-container>

</section>
